import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Vazna_obavjestenja, ApiClientService } from '../../../../services/api-client.service';

@Component({
  selector: 'app-create-vazna-obavjestenja',
  templateUrl: './create-vazna-obavjestenja.component.html',
  styleUrls: ['./create-vazna-obavjestenja.component.scss']
})
export class CreateVaznaObavjestenjaComponent {
  @Input() set visible(value: boolean) {
    this.isVisible = value;
    if (value) {
      this.initializeForm();
    }
  }

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() vaznaObavjestenjaCreated = new EventEmitter<Vazna_obavjestenja>();

  isVisible = false;
  loading = false;
  vaznaObavjestenjaForm!: FormGroup;
  maxDate = new Date();

  datumEditorOptions: any = {
    placeholder: 'Odaberite datum...',
    type: 'date',
    max: this.maxDate,
    displayFormat: "dd.MM.yyyy"
  };

  tekstEditorOptions: any = {
    placeholder: 'Unesite tekst važnog obavještenja...',
    autoResizeEnabled: true,
    height: 100
  };

  constructor(
    private fb: FormBuilder, 
    private apiClient: ApiClientService
  ) {}

  onPopupShown() {
    this.initializeForm();
  }

  initializeForm() {
    this.vaznaObavjestenjaForm = this.fb.group({
      datum: [new Date().toISOString().split('T')[0], Validators.required],
      tekst: ['', Validators.required]
    });
  }

  onFieldDataChanged(e: any) {
    if (e.dataField && e.value !== undefined) {
      this.vaznaObavjestenjaForm.patchValue({
        [e.dataField]: e.value
      });
    }
  }

  onPopupHiding() {
    this.isVisible = false;
    this.visibleChange.emit(false);
  }

  onCancel() {
    this.isVisible = false;
    this.visibleChange.emit(false);
    this.vaznaObavjestenjaForm.reset();
  }

  async onSubmit() {
    if (this.vaznaObavjestenjaForm.valid) {
      this.loading = true;

      try {
        const createdVaznaObavjestenja = await this.apiClient.vaznaObavjestenjaPOST(this.vaznaObavjestenjaForm.value);

        this.vaznaObavjestenjaCreated.emit(createdVaznaObavjestenja);
        this.isVisible = false;
        this.visibleChange.emit(false);
        this.vaznaObavjestenjaForm.reset();

      } catch (error) {
        console.error('Error creating važna obavještenja:', error);
      } finally {
        this.loading = false;
      }
    } else {
      this.markFormGroupTouched(this.vaznaObavjestenjaForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }
}